var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone-Sheet_M",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i_002_PhoneSheet_New",
    transform: "translate(-344.000000, -37.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.708504,49.9066809 L354.803158,45.0000743 L359.708504,40.0932696 C360.097165,39.7066728 360.097165,39.0801878 359.708504,38.6916086 L358.307457,37.2899476 C357.918795,36.9033508 357.292695,36.9033508 356.904231,37.2899476 L352.000669,42.1965541 L347.095323,37.2899476 C346.708841,36.9033508 346.082542,36.9033508 345.694079,37.2899476 L344.292834,38.6916086 C343.902389,39.0801878 343.902389,39.7066728 344.292834,40.0932696 L349.198379,45.0000743 L344.292834,49.9066809 C343.902389,50.2932776 343.902389,50.9199608 344.292834,51.3083419 L345.694079,52.7102011 C346.082542,53.0965996 346.708841,53.0965996 347.095323,52.7102011 L352.000669,47.8033964 L356.904231,52.7102011 C357.292695,53.0965996 357.918795,53.0965996 358.307457,52.7102011 L359.708504,51.3083419 C360.097165,50.9199608 360.097165,50.2932776 359.708504,49.9066809 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross-black.b5d16e23edf347305d968b167e2a0e66.svg";
export { ForwardRef as ReactComponent };